// Tela de diagnóstico: aparece quando faltam as variáveis de conexão.
// Sem isto, o app quebraria com "Failed to fetch" e ninguém saberia o motivo.
//
// O texto falava em "criar o projeto no Supabase" e "Project Settings → API".
// Isso morreu no ADR-006 (05/08/2026): o banco é o da VPS, e o Supabase não
// existe mais neste sistema. A tela mandava para o lugar errado
// justamente quem já estava perdido. Os NOMES das variáveis continuam dizendo
// SUPABASE porque quem as lê é o supabase-js — trocá-los mexeria no deploy, no
// CI e no Caddyfile sem ganho nenhum; o que precisava mudar era o que a tela
// diz que eles significam.
export default function SemConfiguracao() {
  return (
    <div className="mx-auto flex min-h-svh max-w-xl flex-col justify-center gap-5 p-6">
      <h1 className="text-2xl font-black">Sistema não configurado</h1>
      <p className="text-sm text-mute">
        Faltam o endereço da API e a chave de acesso. O app não consegue falar
        com o banco.
      </p>

      <ol className="cartao space-y-3 p-5 text-sm text-mute">
        <li>
          <strong className="text-paper">1.</strong> Copiar{' '}
          <code className="font-mono text-xs">app/.env.example</code> para{' '}
          <code className="font-mono text-xs">app/.env.local</code>.
        </li>
        <li>
          <strong className="text-paper">2.</strong> Deixar{' '}
          <code className="font-mono text-xs">VITE_SUPABASE_URL</code>{' '}
          <strong className="text-paper">vazia</strong> e preencher{' '}
          <code className="font-mono text-xs">VITE_SUPABASE_ANON_KEY</code> com a{' '}
          <code className="font-mono text-xs">DEV_ANON_KEY</code> do{' '}
          <code className="font-mono text-xs">infra/.env.dev</code> na VPS.
          <span className="mt-1 block text-xs text-dim">
            A chave da produção não vale aqui: o ambiente de desenvolvimento tem
            JWT próprio, de propósito — token de um lado não abre o outro.
          </span>
          <span className="mt-1 block text-xs text-dim">
            Isto vale para <strong className="text-paper">desenvolvimento</strong>.
            Se esta tela apareceu no <strong className="text-paper">sistema no
            ar</strong>, a URL vazia é o próprio defeito: em produção ela tem que
            ser o <code className="font-mono">API_ORIGIN</code> do{' '}
            <code className="font-mono">infra/.env</code>, e quem a injeta é o{' '}
            <code className="font-mono">infra/agente/deploy.sh</code>, que compila
            na VPS. Refazer o deploy por lá resolve — nunca buildar e publicar da
            máquina de quem desenvolve.
          </span>
        </li>
        <li>
          <strong className="text-paper">3.</strong> Abrir o túnel para a stack
          de desenvolvimento:
          <code className="mt-1 block bg-ink p-2 font-mono text-xs text-paper">
            ssh -L 8080:127.0.0.1:8080 root@100.111.35.70
          </code>
          <span className="mt-1 block text-xs text-dim">
            O proxy do <code className="font-mono">vite.config.ts</code>{' '}
            encaminha <code className="font-mono">/rest/v1</code> e{' '}
            <code className="font-mono">/auth/v1</code> para lá, então o
            navegador vê uma origem só e não há CORS. Apontar direto para a API
            de produção não funciona: ela libera CORS só para{' '}
            <code className="font-mono">sistema.</code> e{' '}
            <code className="font-mono">clientes.</code>
          </span>
        </li>
        <li>
          <strong className="text-paper">4.</strong> Reiniciar o servidor de
          desenvolvimento.
        </li>
      </ol>

      <p className="text-xs text-dim">
        Os nomes das variáveis dizem <code className="font-mono">SUPABASE</code>{' '}
        porque quem as lê é a biblioteca <code className="font-mono">supabase-js</code>,
        mas desde o ADR-006 elas apontam para a API própria na VPS — PostgREST e
        GoTrue atrás do Caddy, nos mesmos caminhos{' '}
        <code className="font-mono">/rest/v1</code> e{' '}
        <code className="font-mono">/auth/v1</code>.
      </p>

      <p className="text-xs text-dim">
        A anon key pode ir para o frontend porque a RLS está ativa em todas as tabelas.
        A <span className="text-erro">service_role key</span> nunca — ela ignora RLS.
      </p>
    </div>
  );
}
